import React from 'react';

const Input = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder, 
  required, 
  multiline = false,
  rows = 3,
  style = {},
  ...props 
}) => {
  return (
    <div className="form-group">
      {label && <label className="form-label">{label}</label>}
      {multiline ? (
        <textarea
          className="form-input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          required={required}
          style={{ 
            fontFamily: 'monospace',
            fontSize: '14px',
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap',
            ...style 
          }}
          {...props}
        />
      ) : (
        <input
          type={type}
          className="form-input"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          style={style}
          {...props}
        />
      )}
    </div>
  );
};

export default Input;